(() => {
  const initSection = (section) => {
    if (!section || !section.classList.contains('anchor-creator-video-carousel-section')) return;

    const track = section.querySelector('[data-video-track]');
    const prevBtn = section.querySelector('[data-video-prev]');
    const nextBtn = section.querySelector('[data-video-next]');
    const overlay = section.querySelector('[data-video-fullscreen-overlay]');
    const overlayMedia = overlay ? overlay.querySelector('[data-video-fullscreen-media]') : null;

    let activeMediaWrap = null;

    const buildMediaEl = (trigger, targetId) => {
      if (trigger.dataset.videoSource === 'embed') {
        const type = trigger.dataset.videoEmbedType;
        const id = trigger.dataset.videoEmbedId;
        if (!id) return null;

        const src =
          type === 'vimeo'
            ? `https://player.vimeo.com/video/${id}?autoplay=1`
            : `https://www.youtube.com/embed/${id}?autoplay=1&rel=0`;

        const iframe = document.createElement('iframe');
        iframe.src = src;
        iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
        iframe.allowFullscreen = true;
        iframe.setAttribute('frameborder', '0');
        return iframe;
      }

      const template = section.querySelector(`template[data-video-template="${targetId}"]`);
      if (!template) return null;

      const fragment = template.content.cloneNode(true);
      return fragment.querySelector('video');
    };

    const closeFullscreen = () => {
      if (!overlay || !overlayMedia) return;

      const mediaEl = overlayMedia.firstElementChild;
      if (mediaEl && activeMediaWrap) {
        activeMediaWrap.appendChild(mediaEl);
      } else if (mediaEl) {
        mediaEl.remove();
      }

      overlay.classList.remove('acv__fullscreen-overlay--open');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('acv-fullscreen-lock');
      activeMediaWrap = null;
    };

    if (overlay) {
      overlay.querySelectorAll('[data-video-fullscreen-close]').forEach((el) => {
        el.addEventListener('click', closeFullscreen);
      });
    }

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && overlay && overlay.classList.contains('acv__fullscreen-overlay--open')) {
        closeFullscreen();
      }
    });

    section.querySelectorAll('[data-video-card]').forEach((card) => {
      const mediaWrap = card.querySelector('[data-video-media]');
      const playBtn = card.querySelector('[data-video-play]');
      const fsBtn = card.querySelector('[data-video-fullscreen]');
      if (!mediaWrap || !playBtn) return;

      const targetId = playBtn.dataset.videoTarget;
      let currentMedia = null;

      playBtn.addEventListener('click', () => {
        const mediaEl = buildMediaEl(playBtn, targetId);
        if (!mediaEl) return;

        const poster = mediaWrap.querySelector('.acv__poster');
        if (poster) poster.remove();

        mediaWrap.classList.add('acv__media--playing');
        playBtn.hidden = true;
        mediaWrap.appendChild(mediaEl);
        currentMedia = mediaEl;

        if (mediaEl.tagName === 'VIDEO') {
          mediaEl.controls = true;
          mediaEl.play().catch(() => {});
        }

        if (fsBtn) fsBtn.hidden = false;
      });

      if (fsBtn) {
        fsBtn.addEventListener('click', () => {
          if (!currentMedia || !overlay || !overlayMedia) return;
          activeMediaWrap = mediaWrap;
          overlayMedia.appendChild(currentMedia);
          overlay.classList.add('acv__fullscreen-overlay--open');
          overlay.setAttribute('aria-hidden', 'false');
          document.body.classList.add('acv-fullscreen-lock');
        });
      }
    });

    const scrollByCard = (direction) => {
      if (!track) return;
      const card = track.querySelector('[data-video-card]');
      const cardWidth = card ? card.getBoundingClientRect().width : track.clientWidth;
      const gap = 16;
      track.scrollBy({ left: direction * (cardWidth + gap), behavior: 'smooth' });
    };

    if (prevBtn) prevBtn.addEventListener('click', () => scrollByCard(-1));
    if (nextBtn) nextBtn.addEventListener('click', () => scrollByCard(1));
  };

  document.querySelectorAll('.anchor-creator-video-carousel-section').forEach(initSection);

  document.addEventListener('shopify:section:load', (event) => {
    initSection(event.target);
  });
})();
